import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=5993a426&scoped=true"
import script from "./prefectures.vue?vue&type=script&lang=js"
export * from "./prefectures.vue?vue&type=script&lang=js"
import style0 from "./prefectures.vue?vue&type=style&index=0&id=5993a426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5993a426",
  null
  
)

export default component.exports